import { render, staticRenderFns } from "./PagoGracias.vue?vue&type=template&id=39b157c2"
import script from "./PagoGracias.vue?vue&type=script&lang=js"
export * from "./PagoGracias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports